import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ProductSlider extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get productSlides() {
    return get(this, '_product_slides', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/ProductSlider.model.js